import React from "react";
import { Link } from "react-router-dom";

const guestDatabaseData = [
    {
        select_opt: <>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
            </div>
        </>,
        id: 1,
        guest_name: "Mr. John Doe",
        country: "India",
        email: "johndoe@gmail.com",
        mobile: "+91 9876543210",
        vip_status: "Yes",
        actions: <>
            <div class="dropdown">
                <i className="d-affter-icon bi bi-three-dots-vertical text-black dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                <ul class="dropdown-menu">
                    <li><Link to="/edit-guest-database" className="dropdown-item"><i class="bi bi-pencil-square me-2"></i>Edit</Link></li>
                    <li><a class="dropdown-item" href="#"><i class="bi bi-trash me-2"></i>Delete</a></li>
                </ul>
            </div>
        </>
    },
    {
        select_opt: <>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
            </div>
        </>,
        id: 1,
        guest_name: "Mr. John Doe",
        country: "India",
        email: "johndoe@gmail.com",
        mobile: "+91 9876543210",
        vip_status: "Yes",
        actions: <>
            <div class="dropdown">
                <i className="d-affter-icon bi bi-three-dots-vertical text-black dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                <ul class="dropdown-menu">
                    <li><Link to="/edit-guest-database" className="dropdown-item"><i class="bi bi-pencil-square me-2"></i>Edit</Link></li>
                    <li><a class="dropdown-item" href="#"><i class="bi bi-trash me-2"></i>Delete</a></li>
                </ul>
            </div>
        </>
    },
    {
        select_opt: <>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
            </div>
        </>,
        id: 1,
        guest_name: "Mr. John Doe",
        country: "India",
        email: "johndoe@gmail.com",
        mobile: "+91 9876543210",
        vip_status: "Yes",
        actions: <>
            <div class="dropdown">
                <i className="d-affter-icon bi bi-three-dots-vertical text-black dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                <ul class="dropdown-menu">
                    <li><Link to="/edit-guest-database" className="dropdown-item"><i class="bi bi-pencil-square me-2"></i>Edit</Link></li>
                    <li><a class="dropdown-item" href="#"><i class="bi bi-trash me-2"></i>Delete</a></li>
                </ul>
            </div>
        </>
    },
    {
        select_opt: <>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
            </div>
        </>,
        id: 1,
        guest_name: "Mr. John Doe",
        country: "India",
        email: "johndoe@gmail.com",
        mobile: "+91 9876543210",
        vip_status: "Yes",
        actions: <>
            <div class="dropdown">
                <i className="d-affter-icon bi bi-three-dots-vertical text-black dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                <ul class="dropdown-menu">
                    <li><Link to="/edit-guest-database" className="dropdown-item"><i class="bi bi-pencil-square me-2"></i>Edit</Link></li>
                    <li><a class="dropdown-item" href="#"><i class="bi bi-trash me-2"></i>Delete</a></li>
                </ul>
            </div>
        </>
    },
    {
        select_opt: <>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
            </div>
        </>,
        id: 1,
        guest_name: "Mr. John Doe",
        country: "India",
        email: "johndoe@gmail.com",
        mobile: "+91 9876543210",
        vip_status: "Yes",
        actions: <>
            <div class="dropdown">
                <i className="d-affter-icon bi bi-three-dots-vertical text-black dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"></i>
                <ul class="dropdown-menu">
                    <li><Link to="/edit-guest-database" className="dropdown-item"><i class="bi bi-pencil-square me-2"></i>Edit</Link></li>
                    <li><a class="dropdown-item" href="#"><i class="bi bi-trash me-2"></i>Delete</a></li>
                </ul>
            </div>
        </>
    },
]

const GuestDatabase = () => {
    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <h3 className="fw-bold mb-0">Guest Database</h3>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead className="">
                                        <tr className="small text-uppercase">
                                            <th></th>
                                            <th>Guest Name</th>
                                            <th>Country</th>
                                            <th>Email</th>
                                            <th>Mobile</th>
                                            <th>VIP Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {guestDatabaseData.map((data, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{data.select_opt}</td>
                                                    <td>{data.guest_name}</td>
                                                    <td>{data.country}</td>
                                                    <td>{data.email}</td>
                                                    <td>{data.mobile}</td>
                                                    <td>{data.vip_status}</td>
                                                    <td>{data.actions}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GuestDatabase